import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7879f9a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "やり取り可能数を増やす", -1))
const _hoisted_3 = { class: "noMargin" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "すでにやり取りを開始したものは「やり取り停止」をすることでやり取り可能数を増やすことができます。現在進行中のやり取りがある求人はやり取り停止することができません。", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "noMargin" }, "「やり取り停止」したいものを全て選択してください。", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("すべて解除する")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("すべて選択する")
const _hoisted_8 = { class: "label" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "余った追加契約の解除", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "すでにお支払いいただいた代金の返金は承っておりません。ご了承ください。", -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 件 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("の追加購入を解除します。 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("解約する")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "基本契約の解除", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "すでにお支払いいただいた代金の返金は承っておりません。ご了承ください。", -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "サブスクリプションは全て解除されます。", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode("基本契約の解除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_empty = _resolveComponent("n-empty")!
  const _component_n_checkbox = _resolveComponent("n-checkbox")!
  const _component_n_checkbox_group = _resolveComponent("n-checkbox-group")!
  const _component_n_input_number = _resolveComponent("n-input-number")!
  const _component_n_layout = _resolveComponent("n-layout")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createBlock(_component_n_space, {
    vertical: "",
    style: {"padding":"10px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_layout, { style: {"padding":"10px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_Menu),
          (!_ctx.inited)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_2,
                _createElementVNode("p", _hoisted_3, "現在のやり取り可能数: " + _toDisplayString(_ctx.allTicket - _ctx.initialUsedTicket), 1),
                _hoisted_4,
                _hoisted_5,
                _createVNode(_component_n_button, {
                  quaternary: "",
                  type: "primary",
                  onClick: _ctx.selectAll,
                  disabled: !_ctx.list.length
                }, {
                  default: _withCtx(() => [
                    (_ctx.isAllSeled)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_6
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_7
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                (!_ctx.list.length)
                  ? (_openBlock(), _createBlock(_component_n_empty, {
                      key: 0,
                      description: "応募はまだありません"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_n_checkbox_group, {
                  value: _ctx.unsubscribe,
                  "onUpdate:value": [
                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.unsubscribe) = $event)),
                    _ctx.handleUpdateValue
                  ]
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (a) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "horizontal",
                        key: a.id
                      }, [
                        _createVNode(_component_n_checkbox, {
                          value: a.id,
                          label: " ",
                          disabled: !!a.unremoveable
                        }, null, 8, ["value", "disabled"]),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(a.labelTag), 1),
                        _createElementVNode("div", null, _toDisplayString(a.unremoveable || '【やり取り停止可能】この求人のやり取りは見ることができなくなります'), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onUpdate:value"]),
                _hoisted_9,
                _hoisted_10,
                (_ctx.value < _ctx.max)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, "追加購入分が" + _toDisplayString(_ctx.max - _ctx.value) + "件余っています。", 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_12, "解約可能なものを全て解約します。上の求人をまだ選択できる場合、選択することで増やすことができます。なお、ここでは全ての契約を解除することができません。")),
                _createVNode(_component_n_input_number, {
                  value: _ctx.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
                  placeholder: "0",
                  min: _ctx.min,
                  max: _ctx.max,
                  style: {"width":"150px"}
                }, {
                  suffix: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["value", "min", "max"]),
                _hoisted_14,
                _createElementVNode("p", null, "変更前: " + _toDisplayString(_ctx.allTicket) + "(" + _toDisplayString(_ctx.calc(_ctx.allTicket)) + "円/月) →変更後: " + _toDisplayString(_ctx.getNewTicket()) + "(" + _toDisplayString(_ctx.getNewPrice()) + "円/月)", 1),
                _createVNode(_component_n_button, {
                  type: "primary",
                  disabled: _ctx.value === 0 && !_ctx.unsubscribe.length,
                  onClick: _ctx.cancel,
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick", "loading"]),
                (!_ctx.archiveOnly)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _hoisted_16,
                      _hoisted_17,
                      (!_ctx.allCancelable)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, "進行中のやり取りがあるため、解除することができません。"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _hoisted_20,
                            _createVNode(_component_n_button, {
                              type: "error",
                              loading: _ctx.loading,
                              onClick: _ctx.allCancel
                            }, {
                              default: _withCtx(() => [
                                _hoisted_21
                              ]),
                              _: 1
                            }, 8, ["loading", "onClick"])
                          ]))
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}